













































import { Cadastros } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import ChartDoughnut from "@/shared/components/chart-doughnut.vue";
import GraficoLegenda from "../GraficoLegenda.vue";

@Component({
  components: { ChartDoughnut, GraficoLegenda },
})
export default class GraficoDonutCadastrosMensais extends Vue {
  centro = {
    title: "Cadastros",
    value: 0,
  };

  isLargeValue = false;

  options: Chart.ChartOptions = {
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 76,
    responsive: false
  };

  @Prop() readonly loading!: boolean;
  @Prop() readonly value!: Cadastros[];
  @Prop() readonly dataMes!: string | null | Date;
  @Prop() readonly height!: number;
  @Prop() readonly width!: number;

  get dataSet(): Chart.ChartDataSets[] {
    const source = this.value ?? [];
    return [
      {
        backgroundColor: [
          "#258D3F",
          "#A2E5B3",
        ],
        data: [
          source.length > 0 ? source.map((x) => x.quantidadeApp ?? 0).reduce((a, b) => a + b) : 0,
          source.length > 0 ? source.map((x) => x.quantidadeSite ?? 0).reduce((a, b) => a + b) : 0,
        ],
      },
    ];
  }

  @Watch("value")
  onValueChange() {
    const source = this.value ?? [];
    this.centro.value =
      source.length > 0
        ? source.map((x) => x.quantidadeSite ?? 0).reduce((a, b) => a + b) + source.map((x) => x.quantidadeApp ?? 0).reduce((a, b) => a + b) : 0;
    this.isLargeValue = this.centro.value.toString().length > 3;
    }

  mounted() {
    this.onValueChange();
  }
}
